// import Swiper from "swiper/bundle";

/* global swiper: false */

export default class ControlledSwiper {
	constructor(selector) {
		this.sectionEl = selector;

		if (!this.sectionEl) return;

		this.defaultSettings = {};

		this.swiperEl1 = this.sectionEl.querySelector(".swiper-1");
		this.swiperEl2 = this.sectionEl.querySelector(".swiper-2");

		if (!this.swiperEl1) return;

		this.init();
	}

	init() {
		if ( this.swiperEl1 && this.swiperEl1.dataset && this.swiperEl1.dataset.swiper ) {
			this.swiper1 = new Swiper(
				this.swiperEl1,
				JSON.parse(this.swiperEl1.dataset.swiper)
			);
		}

		if ( this.swiperEl2 && this.swiperEl2.dataset && this.swiperEl2.dataset.swiper ) {
			this.swiper2 = new Swiper(
				this.swiperEl2,
				JSON.parse(this.swiperEl2.dataset.swiper)
			);

			this.swiper1.controller.control = this.swiper2;
			this.swiper2.controller.control = this.swiper1;
		}
	}
}
